import(/* webpackMode: "eager" */ "/app/src/app/bang-gia/[post]/page.js");
